<template lang="pug" src="./html/CadburyYouTubeDanceOff.pug"></template>

<script>

  import Vue from 'vue'
  import PortfolioItemBase from './PortfolioItemBase'

  const CadburyYouTubeDanceOffBody = () => import(/* webpackChunkName: "cadbury-youyube-dance-off" */ './CadburyYouTubeDanceOff-Body')

  Vue.component('CadburyYouTubeDanceOffBody', CadburyYouTubeDanceOffBody)

  export default {
    extends: PortfolioItemBase,
    mounted () {
      this.setBody('CadburyYouTubeDanceOffBody')
    }
  }
</script>

<style lang="sass" src="./style/PortfolioItem.sass"></style>

<style scoped>
    .portfolio-item {
        background-color: #3D2770;
    }
    .portfolio-item, a {
        color: #CDCDCB;
    }
    .portfolio-item .logo {
        height: 4.5em;
        padding-top: .8em;
    }
    .portfolio-item .logo img {
        height: 75%;
        padding-left: 3em;
        padding-right: 3em;
    }
    h1 {
        color: #EFEBE4;
    }
    .label, h2 {
        color: #FDB52B;
    }
</style>

<style>
    #app.cadbury-youtube-dance-off #top-header {
        background-color: #492d8c;
    }
</style>
